import ClaimRow from "./ClaimRow";
import { useTranslation } from "../../hooks/useTranslation";

export default function ClaimTable({ claims }) {
  const { t } = useTranslation();

  return (
    <div
      id="kt_customers_table_wrapper"
      className="dt-container dt-bootstrap5 dt-empty-footer"
    >
      <div className="table-responsive">
        <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable">
          <thead>
            <tr className="text-start fw-bold fs-7 text-uppercase gs-0">
              <th>{t("claims.claimId")}</th>
              <th>{t("claims.opportunity")}</th>
              <th>{t("claims.invoiceNumber")}</th>
              <th>{t("claims.state")}</th>
              <th>{t("claims.createdDate")}</th>
              <th>{t("claims.description")}</th>
              <th className="min-w-100px text-end">{t("common.actions")}</th>
            </tr>
          </thead>
          <tbody className="fw-semibold text-gray-600">
            {claims?.data?.length > 0 &&
              claims.data.map((claim, key) => (
                <ClaimRow claim={claim} key={key} />
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
